import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import { renderFavicons } from '@awaze/design-system.components.mfe-head-common'
import Head from 'next/head'

export interface CustomHeadProps {
  pageName: string
  brand: Brand
  content: string
}

export const CustomHead: React.FC<CustomHeadProps> = ({
  brand,
  pageName,
  content,
}: CustomHeadProps): JSX.Element => {
  const title = `${pageName} | ${brand.charAt(0).toUpperCase() + brand.slice(1)}`
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={content} />
      <meta charSet="UTF-8" />

      {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        renderFavicons(brand as any)
      }
    </Head>
  )
}
